import React from "react";
import style from "./NotFoundPage.module.css"

export default function NotFoundPage() {
  return (
    <>
      <div className ={`text-center bg-secondary w-100 text-white py-2 ${style.test}`} >
        <h2>4 0 4</h2>
        <p>Page not found!!</p>
      </div>
    </>
  );
}
